module.exports = __webpack_public_path__ + "img/dk.e39ae472.svg";